// src/pages/PurchasePage.js
import React, {useEffect, useMemo, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {useAuth} from "../contexts/authContext";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

export default function PurchasePage() {
  const navigate = useNavigate();
  const [loadingId, setLoadingId] = useState(null);
  const [tab, setTab] = useState("prepaid"); // 'prepaid' | 'subscription'
  const token = localStorage.getItem("token");
  const [userNickname, setUserNickname] = useState('');
  const { isLoggedIn, setIsLoggedIn, userEmail, setUserEmail } = useAuth();

  useEffect(() => {
    const nickname = localStorage.getItem("nickname");
    if (nickname) setUserNickname(nickname);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("nickname");
    localStorage.removeItem("usage_count");
    localStorage.removeItem("daily_limit");
    setIsLoggedIn(false);
    setUserEmail("");
    alert("로그아웃 되었습니다.");
    navigate("/login");
  };

  const prepaid = useMemo(() => ([
    { id: "prod_7GM3hsa1CHo9yqNMeGZ0KW", title: "50회 충전", priceLabel: "$4.50", desc: "필요할 때마다 차감", type: "prepaid" },
    { id: "prod_59CQfDWs9QlG29wwNXWKY2", title: "100회 충전", priceLabel: "$8.50", desc: "가성비 인기", type: "prepaid" },
    { id: "prod_VdOGiX6gP9a86cK3G8Tfx", title: "200회 충전", priceLabel: "$16.00", desc: "헤비유저 추천", type: "prepaid" },
  ]), []);

  const subs = useMemo(() => ([
   { id: "prod_7WVA6J6FJkChixbaWSaJOc", title: "Basic (15/일)", priceLabel: "$21.99 (30일)", desc: "30일 동안 매일 15회 · 자동결제 없음", type: "subscription" },
   { id: "prod_38W71VcmyEtr4PJN4invyj", title: "Pro (30/일)",   priceLabel: "$39.99 (30일)", desc: "30일 동안 매일 30회 · 자동결제 없음", type: "subscription" },
   { id: "prod_37Ws4lFF8CqH3w3kvuHc9n", title: "Power (60/일)", priceLabel: "$69.99 (30일)", desc: "30일 동안 매일 60회 · 자동결제 없음", type: "subscription" },
  ]), []);

  async function buy(productId) {
    if (!token) {
      alert("로그인이 필요합니다.");
      navigate("/login");
      return;
    }
    try {
      setLoadingId(productId);
      const res = await fetch(`${API_BASE_URL}/creem/checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          product_id: productId,
          success_url: `${API_BASE_URL}/creem/return`, // 백엔드 리턴 URL
        }),
      });
      const raw = await res.text();
      let json; try { json = JSON.parse(raw); } catch {}
      if (!res.ok || !json?.ok || !json?.checkout_url) {
        console.error("checkout fail", res.status, raw);
        alert(`결제 준비 실패: ${res.status} ${json?.detail || raw}`);
        return;
      }
      window.location.href = json.checkout_url;
    } catch (e) {
      console.error(e);
      alert(e.message || "오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
    } finally {
      setLoadingId(null);
    }
  }

  const list = tab === "prepaid" ? prepaid : subs;

  return (
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-white">
        <header
            className="w-full flex flex-col md:flex-row justify-between items-center px-4 py-4 border-b bg-white dark:bg-gray-800">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h1 className="text-xl font-bold text-blue-600 dark:text-blue-300">J_Universe</h1>

            <nav className="mt-2 text-sm">
              <Link to="/" className="hover:text-blue-400">J_Universe</Link>
              <span className="mx-2">|</span>
            </nav>
          </div>

          <div className="flex flex-col items-end gap-2 mt-4 md:mt-0">
            {isLoggedIn && (
                <div className="text-sm font-semibold text-green-300 text-center md:text-right w-full">
                  어서오세요, <span className="text-yellow-400">{userNickname}</span> 님
                </div>
            )}
            <div className="flex gap-2">
              {isLoggedIn ? (
                  <button
                      onClick={handleLogout}
                      className="px-4 py-2 text-sm font-semibold bg-red-500 text-white rounded-full">
                    Sign out
                  </button>
              ) : (
                  <Link
                      to="/login"
                      className="px-4 py-2 text-sm font-semibold bg-blue-500 text-white rounded-full">
                    Sign in
                  </Link>
              )}
               {!isLoggedIn && (
                <Link
                  to="/signup"
                  className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
                >
                  Sign up
                </Link>
              )}
              {isLoggedIn && (
                <Link
                  to="/mypage"
                  className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
                >
                  MyPage
                </Link>
              )}
            </div>
          </div>
        </header>
        <div className="min-h-screen bg-gray-100 dark:bg-gray-900 p-6">
          <div className="max-w-lg mx-auto">
            <h1 className="text-2xl font-bold text-center text-gray-800 dark:text-gray-100 mb-6">구매하기</h1>
              <p className="mt-4 text-[13px] text-gray-400">
                ※ 느긋하게 사용하는 유저에겐 횟수 충전권을 추천하며, 매일 많은 횟수를 사용하는 유저에겐 기간권을 추천합니다.
              </p>
            {/* 탭 */}
            <div className="flex gap-2 justify-center mb-4">
              <button
                onClick={() => setTab("prepaid")}
                className={`px-4 py-2 rounded-lg ${tab === "prepaid" ? "bg-blue-600 text-white" : "bg-gray-300 dark:bg-gray-700 text-gray-900 dark:text-gray-100"}`}
              >
                횟수 충전
              </button>
              <button
                onClick={() => setTab("subscription")}
                className={`px-4 py-2 rounded-lg ${tab === "subscription" ? "bg-blue-600 text-white" : "bg-gray-300 dark:bg-gray-700 text-gray-900 dark:text-gray-100"}`}
              >
                기간권(30일)
              </button>
            </div>

            {/* 카드 리스트 */}
            <div className="grid gap-4">
              {list.map(p => (
                <div key={p.id} className="bg-white dark:bg-gray-800 rounded-xl shadow p-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">{p.title}</div>
                      <div className="text-sm text-gray-600 dark:text-gray-300">{p.desc}</div>
                    </div>
                    <div className="text-right">
                      <div className="text-xl font-bold text-blue-600 dark:text-blue-300">{p.priceLabel}</div>
                      <div className="text-xs text-gray-500">
                        {p.type === "prepaid" ? "Prepaid" : "30-day pass"}
                      </div>
                    </div>
                  </div>

                  <button
                    onClick={() => buy(p.id)}
                    disabled={loadingId === p.id}
                    className="mt-4 w-full py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-60"
                  >
                    {loadingId === p.id ? "결제 페이지로 이동중..." : "구매하기"}
                  </button>
                  {tab === "subscription" && (
                    <p className="mt-4 text-[11px] text-gray-500">
                      * 해당 상품은 매일 구매한 일일 횟수가 충전되며, 일일 횟수를 초과하여 누적 충전되지않습니다.
                      <br/>
                      * 결제일부터 30일간 활성화되며 기간 종료시에는 횟수가 충전되지않습니다.
                      <br/>
                      * 환불 진행 시 일부 수수료는 환불되지 않을 수 있습니다.
                    </p>
                  )}
                  {tab === "prepaid" && (
                    <p className="mt-4 text-[11px] text-gray-500">
                      * 해당 상품은 구매시 구매한 횟수가 충전되며, 소진시까지 사라지지 않습니다.
                      <br/>
                      * 환불 진행 시 일부 수수료는 환불되지 않을 수 있습니다.
                    </p>
                  )}
                </div>
              ))}
            </div>

            <button
              onClick={() => navigate(-1)}
              className="mt-6 w-full py-2 rounded-lg bg-gray-300 dark:bg-gray-700 text-gray-900 dark:text-gray-100 hover:bg-gray-400 dark:hover:bg-gray-600"
            >
              돌아가기
            </button>
          </div>
        </div>
      </div>
  );
}
